import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import classNames from 'classnames';
import { useUrlGenerator } from '@folklore/react-container';
import { useLocation } from 'react-router-dom';
import Link from './Link';
// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/menu.scss';

const messages = defineMessages({
    film: {
        id: 'content.sections_title.film',
        defaultMessage: 'Film',
    },
    stories: {
        id: 'content.sections_title.stories',
        defaultMessage: 'Stories',
    },
    articles: {
        id: 'content.sections_title.articles',
        defaultMessage: 'Articles',
    },
    interactive: {
        id: 'content.sections_title.interactive',
        defaultMessage: 'Interactive',
    },
    community: {
        id: 'content.sections_title.community',
        defaultMessage: 'Community',
    },
    screenings_news: {
        id: 'content.sections_title.screenings_news',
        defaultMessage: 'Screenings & News',
    },
});

const propTypes = {
    onClickItem: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    onClickItem: null,
    className: null,
};

const Menu = ({ onClickItem, className }) => {
    const urlGenerator = useUrlGenerator();
    const location = useLocation().pathname;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <Link
                to={urlGenerator.route('home')}
                onClick={onClickItem == null ? null : () => onClickItem()}
                style={location === '/' ? { color: '#fff', fontWeight: 700 } : null}
            >
                {messages.film}
            </Link>
            <Link
                to={urlGenerator.route('stories')}
                onClick={onClickItem == null ? null : () => onClickItem()}
                style={location === '/stories' ? { color: '#fff', fontWeight: 700 } : null}
            >
                {messages.stories}
            </Link>
            <Link
                to={urlGenerator.route('articles')}
                onClick={onClickItem == null ? null : () => onClickItem()}
                style={location === '/articles' ? { color: '#fff', fontWeight: 700 } : null}
            >
                {messages.articles}
            </Link>
            <Link
                to={urlGenerator.route('community')}
                onClick={onClickItem == null ? null : () => onClickItem()}
                style={location === '/community' ? { color: '#fff', fontWeight: 700 } : null}
            >
                {messages.community}
            </Link>
            <Link
                to={urlGenerator.route('screenings')}
                onClick={onClickItem == null ? null : () => onClickItem()}
                style={
                    location === '/screenings-and-news' ? { color: '#fff', fontWeight: 700 } : null
                }
            >
                {messages.screenings_news}
            </Link>
        </div>
    );
};

Menu.propTypes = propTypes;
Menu.defaultProps = defaultProps;

export default injectIntl(Menu);

// <Link
//     to={urlGenerator.route('interactive')}
//     onClick={onClickItem == null ? null : () => onClickItem()}
// >
//     {messages.interactive}
// </Link>
